/// <amd-module name="Test/FilteringLogic/Services/TrendChartSourceService" />
import * as CommonTypes from "Test/Analytics/Common/Types";
import { ITrendChartData, ITrendChartSource } from "Test/Analytics/TrendChartCommon/Types";
import { TrendChartSource } from "Test/FilteringLogic/Sources/TrendChartSource";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";

export class TrendChartSourceService extends VssService implements ITrendChartSource {
    private _trendChartSource: TrendChartSource;

    public initialize(command: string, pageContext: IVssPageContext) {
        this._trendChartSource = new TrendChartSource(pageContext);
    }

    public queryTrendChartData(
        testReportContext: CommonTypes.ITestReportContext,
        confValues: CommonTypes.IReportConfiguration,
        chartMetric: CommonTypes.Metric
    ): Promise<ITrendChartData> {
        return this._trendChartSource.queryTrendChartData(testReportContext, confValues, chartMetric);
    }
}

Services.add("TrendChartSourceService", { serviceFactory: TrendChartSourceService });
